import { Box, Button, Divider, Flex, Heading, Image, Spacer, Text, VStack } from "@chakra-ui/react";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { useRef, useState } from "react";

// Components
import SlideModal from "../../Components/Slide/SlideModal";

// Images
import MovilDownMovil from '../../Assets/MOVIL/Banner-Inferior-Mobile.webp';
import MovilDown from '../../Assets/MOVIL/Banner-Inferior-Desktop.webp';
import BannerDk from '../../Assets/MOVIL/ImagenBanner-Desktop.webp';
import BannerMb from '../../Assets/MOVIL/ImagenBanner-Movil.webp';

// Styles
import '@splidejs/react-splide/css/sea-green';
import '@splidejs/react-splide/css/skyblue';
import './style.css';

// Icons
import { IconMundo, IconPhone, IconRed, IconUserPhone } from "../../Assets/MOVIL/Icons";
import { IconArrowRight } from "../../Assets/GENERALES/Icons";

const Movil = () => {

    const [precioNormalSolicitado, setPrecioNormalSolicitado] = useState('');
    const [precioSolicitado, setPrecioSolicitada] = useState('');
    const [openSlideModal, setOpenSlideModal] = useState(false);
    const [planSolicitado, setPlanSolicitada] = useState('');
    const [descuentoPlan, setDescuentoPlan] = useState('');
    const [isBanner, setIsBanner] = useState(false);
    const [id, setId] = useState('');
    const splideRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const perPage = 3;

    const planes = [
        {
            id: '1',
            planid: 'POSTPAID_FAMILY_200GB',
            plan: 'Postpaid Family Plan',
            gigas: '200GB',
            minutes: '1000',
            benefits: [
                'Your plan includes Free Digicel Minutes'
            ],
            precio: '500.00',
            currency: 'TTD',
            taxInfo: '/month (Tax incl.)',
            caribbeanData: ''
        },
        {
            id: '2',
            planid: 'MY_CHOICE_40GB',
            plan: 'My Choice Plan',
            gigas: '40GB',
            minutes: '400',
            caribbeanData: '1GB',
            benefits: [
                'Free Local SMS',
                'Your plan includes Free Digicel Minutes'
            ],
            precio: '300.00',
            currency: 'TTD',
            taxInfo: '/month (Tax incl.)'
        },
        {
            id: '3',
            planid: 'MY_VALUE_MAX_450GB',
            plan: 'My Value Max Plan',
            gigas: '450 GB',
            minutes: 'Free',
            caribbeanData: '5GB',
            benefits: [
                'Free Local SMS',
                'Your plan includes Free Digicel Minutes'
            ],
            precio: '500.00',
            currency: 'TTD',
            taxInfo: '/month (Tax incl.)'
        },
        {
            id: '4',
            planid: 'MY_CONNECT_3GB',
            plan: 'My Connect Plan',
            subtitle: '60+ Yrs Only',
            gigas: '3 GB',
            minutes: '300',
            benefits: [
                'Your plan includes Free Digicel Minutes'
            ],
            precio: '219.99',
            currency: 'TTD',
            taxInfo: '/month (Tax incl.)'
        },
        {
            id: '5',
            planid: 'MY_ALL_INCLUSIVE_800GB',
            plan: 'My All Inclusive Plan',
            gigas: '800 GB',
            caribbeanData: '10 GB',
            benefits: [
                'Your plan includes Free Digicel Minutes'
            ],
            precio: '650.00',
            currency: 'TTD',
            taxInfo: '/month (Tax incl.)'
        }
    ];

    const infoCards = [
        {
            title: "Sign Up",
            description: "Complete the form on our website"
        },
        {
            title: "We'll Contact You",
            description: "Our agent will call you within 24-48 Hours for acceptance and arrange for delivery"
        },
        {
            title: "Account Will Be Activated",
            description: "Once all credit checks are completed and approved, we'll activate your account."
        }
    ];

    const openSlide = (view, targetId, segment, targetGigas, targetPrecio, targetPrecioNormal, targetDcto, targetPlanid) => {
        if (view !== 'Banner') {
            setId(`Form_plan_${targetId}`);
            setPrecioNormalSolicitado(targetPrecioNormal);
            setDescuentoPlan(targetDcto);
            setPrecioSolicitada(targetPrecio);
            setPlanSolicitada(targetGigas);
            setIsBanner(false);
        } else {
            setId(targetId);
            setPrecioNormalSolicitado('');
            setDescuentoPlan('');
            setPrecioSolicitada('');
            setPlanSolicitada('Formulario Banner');
            setIsBanner(true);
        }

        setOpenSlideModal(true);
    };

    return (
        <>
            {/* Banner */}
            <Box position="relative" w="100%" h={['300px', '300px', '300px', '520px', '520px']} onClick={() => openSlide('Banner', 'Form_Banner_ppal_1')}>
                <Image
                    src={BannerDk}
                    srcSet={`${BannerMb} 768w, ${BannerDk} 1024w`}
                    sizes="(max-width: 768px) 100px, 1024px"
                    alt="Banner Digicel Mobile Plans"
                    objectFit="cover"
                    objectPosition='center'
                    w="100%"
                    h="100%"
                    loading="eager"
                />
                <Flex position="absolute" bottom={[4,4,4,10,10]} w={["40%", "40%", "40%", "95%", "95%"]} alignItems='center'  flexDirection="row" px={[4,4,10,20,20]}>
                    <Box my="auto" color="white">
                        {/* <Heading as="h1" mt='5' color='#E4002B' fontWeight="400" fontSize={['22px', '22px', '40px']} className="Subtitle" lineHeight="1">
                            Football Lives Here, Sign Up For
                        </Heading>
                        <Heading as="h2" className='Title' color='#E4002B' fontWeight="400" fontSize={['22px', '22px', '40px']} lineHeight="1">
                            A Postpaid Plan
                        </Heading> */}
                        <Button bg='#fff' fontSize='xl' px='14' color='#E4002B' className="Title" borderRadius='20px' py='2' mt='5'>
                            I want it
                        </Button>
                    </Box>
                    <Spacer />
                </Flex>
            </Box>

            {/* Planes */}
            <Box py="10" >
                <Box maxW="1200px" mx="auto" px="5" position="relative">
                    <Splide
                        ref={splideRef}
                        className="plans-splide"
                        options={{
                            perPage: 3,
                            perMove: 1,
                            gap: "80px",
                            pagination: true,
                            arrows: false,
                            breakpoints: {
                                1200: {
                                    perPage: 2,
                                    arrows: false,
                                    gap: "16px",
                                },
                                768: {
                                    perPage: 1,
                                    arrows: false,
                                    gap: "16px",
                                }
                            }
                        }}
                        onInit={(splide) => setCurrentIndex(splide.index)}
                        onMoved={(_splide, newIndex) => setCurrentIndex(newIndex)}
                    >
                        {planes.map((target) => (
                            <SplideSlide key={target.id}>
                                <Flex
                                    bg="#F4F4F4"
                                    border="1px solid #E2E8F0"
                                    borderRadius="24px"
                                    p="8"
                                    flexDirection="column"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    textAlign="center"
                                    boxShadow="sm"
                                    transition="all 0.2s"
                                    _hover={{ boxShadow: "md", transform: "translateY(-2px)" }}
                                    h="auto"
                                >
                                    <Box w='100%' position='absolute' top='0' borderTopRadius='24px' bg='#E4002B' color='white' textAlign='center'>
                                        <Text className="General" fontSize='lg'>Get your plan now</Text>
                                    </Box>
                                    {/* Header Info */}
                                    <Box w="100%">
                                        <Text 
                                            className="General" 
                                            fontSize="lg" 
                                            color="#E4002B" 
                                            mb="2"
                                            mt='4'
                                            letterSpacing="wider"
                                        >
                                            {target.plan}
                                        </Text>

                                        {target.subtitle && (
                                            <Text 
                                                className="Title" 
                                                fontSize="2xl" 
                                                fontWeight="extrabold" 
                                                color="#212121"
                                                mb="2"
                                            >
                                                {target.subtitle}
                                            </Text>
                                        )}

                                        <Flex gap='2'>
                                            <IconMundo size="22" />
                                            <Heading 
                                                className="General" 
                                                fontSize="xl" 
                                                color="#212121" 
                                                fontWeight="black"
                                                mb="2"
                                            >
                                                <strong className="Title">{target.gigas}</strong> Any Use Data
                                            </Heading>
                                        </Flex>

                                        {target.caribbeanData && (
                                            <Flex gap='2' mb="2">
                                                <IconRed size="22" />
                                                <Heading 
                                                    className="Subtitle" 
                                                    fontSize="xl" 
                                                    color="#212121" 
                                                    fontWeight="extrabold"
                                                >
                                                    <strong className="Title">{target.caribbeanData}</strong> Digicel Caribbean
                                                </Heading>
                                            </Flex>
                                        )}

                                        {target.minutes && (
                                            <Flex gap='2' mb="2">
                                                <IconPhone size='22' />
                                                <Heading 
                                                    className="Subtitle" 
                                                    fontSize="xl" 
                                                    color="#212121"
                                                >
                                                    <strong className="Title">{target.minutes}</strong> Anywhere Minutes
                                                </Heading>
                                            </Flex>
                                        )}
                                    </Box>

                                    <Divider my="2" borderColor="#747272" />

                                    {/* Middle Benefits */}
                                    <Flex justifyContent='center' alignItems='center' mb="6">
                                        <IconUserPhone size='50' />
                                        <VStack spacing="0" alignItems='start' w="100%" px="2">
                                            {target.benefits.map((benefit, idx) => (
                                                <Text 
                                                    key={idx} 
                                                    textAlign='left'
                                                    className="Subtitle" 
                                                    fontSize="lg" 
                                                    color="#212121"
                                                >
                                                    {benefit}
                                                </Text>
                                            ))}
                                        </VStack>
                                    </Flex>

                                    {/* Pricing and Action */}
                                    <Box w="100%">
                                        <Flex justifyContent="start" alignItems="start" mb="1" gap="1">
                                            <Text 
                                                className="Title" 
                                                fontSize="sm" 
                                                fontWeight="bold" 
                                                color="#E4002B"
                                                alignSelf="flex-end"
                                                pt="1"
                                            >
                                                {target.currency}
                                            </Text>
                                            <Heading
                                                className="Title"
                                                fontSize="4xl"
                                                color="#E4002B"
                                                fontWeight="black"
                                                lineHeight="1"
                                            >
                                                {target.precio}
                                            </Heading>
                                        </Flex>

                                        <Text className="Subtitle" textAlign='left' fontSize="md" color="#252525" mb="5">
                                            {target.taxInfo}
                                        </Text>

                                        <Button
                                            onClick={() => openSlide('tarjeta', target.id, 'Movil', target.plan, target.precio, '', '', target.planid)}
                                            px='10'
                                            py="6" 
                                            bg="#E4002B"
                                            fontSize='2xl'
                                            color="white"
                                            borderRadius="30"
                                            className="Subtitle gtm_planes_btn_cta"
                                            _hover={{ bg: "transparent", color: "#E4002B", border: "2px solid #E4002B" }}
                                            transition="all 0.2s"
                                        >
                                            Get this plan
                                        </Button>
                                    </Box>
                                </Flex>
                            </SplideSlide>
                        ))}
                    </Splide>

                    {/* Previous Arrow */}
                    {currentIndex > 0 && (
                        <Box
                            position="absolute"
                            left="0"
                            top="50%"
                            transform="translateY(-50%)"
                            zIndex="1"
                            cursor="pointer"
                            display={["none", "none", "flex", "flex", "flex"]}
                            onClick={() => splideRef.current?.go('-')}
                            className="arrow-next"
                            style={{ transform: 'rotate(180deg)' }}
                            alignItems="center"
                            justifyContent="center"
                        >
                            <IconArrowRight color="#E4002B" size="24" />
                        </Box>
                    )}

                    {/* Next Arrow */}
                    {currentIndex < planes.length - perPage && (
                        <Box
                            position="absolute"
                            right="0"
                            top="50%"
                            transform="translateY(-50%)"
                            zIndex="1"
                            cursor="pointer"
                            display={["none", "none", "flex", "flex", "flex"]}
                            onClick={() => splideRef.current?.go('+')}
                            className="arrow-next"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <IconArrowRight color="#E4002B" size="24" />
                        </Box>
                    )}
                </Box>
            </Box>

            <Heading textAlign="center" className="Title" fontSize="4xl" fontWeight="black" color="#E4002B" mt="10">How to get started.</Heading>

            {/* Info down */}
            <Box
                backgroundImage={[MovilDownMovil, MovilDownMovil, MovilDown]}
                backgroundSize="cover"
                height={['350px','350px','500px','500px','500px']}
                backgroundPosition="center"
                backgroundRepeat="no-repeat"
                pos='relative'
                my={[0, 0, 10, 10, 10]}
                py={[10, 10, 16, 16, 16]}
                px={["7%", "7%", "7%", "7%", "7%"]}
            >
                <Button pos='absolute' borderRadius='30px' onClick={() => openSlide('Banner', 'Form_Banner_second_1')} bgColor='#E4002B' color='white' bottom={[5,5,10,16,16]} px='14' size='lg'>
                    Get this plan
                </Button>
            </Box>

            {/* Modal */}
            {openSlideModal && (
                <Box
                    position="fixed"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    backgroundColor="rgba(0, 0, 0, 0.5)"
                    zIndex="9"
                >
                    <SlideModal
                        setOpenSlideModal={setOpenSlideModal}
                        priceTyc={precioNormalSolicitado}
                        openSlideModal={openSlideModal}
                        descuento={descuentoPlan}
                        price={precioSolicitado}
                        valuePhoneInitial={''}
                        plan={planSolicitado}
                        submitInitial={false}
                        id={id}
                    />
                </Box>
            )}
        </>
    );
};

export default Movil;